import { useMemo } from 'react';

import { InfoOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { getIn, useFormikContext } from 'formik';

import { CissNumberField } from 'components/fields';
import { DreFormGroup } from 'pages/financeiro/dre/components/templates/DreFormGroup';
import { DreFormRow } from 'pages/financeiro/dre/components/templates/DreFormRow';
import { useRecalculateDre } from 'pages/financeiro/dre/hooks';
import { DreForm, DreImpostosConfiguracao } from 'pages/financeiro/dre/types';
import { getLines } from 'pages/financeiro/dre/utils';

export function DreFormImpostos() {
    const { errors, values, setFieldValue } = useFormikContext<DreForm>();
    const { recalculateValidatedDre } = useRecalculateDre();

    return useMemo(
        () => (
            <DreFormGroup label="Impostos" id="5">
                {Object.entries(getLines<DreImpostosConfiguracao>(values.dreMercadologicaImpostos, 'dreMercadologicaConfigImposto')).map(
                    ([line, configuracoes]) => (
                        <DreFormRow key={line}>
                            {configuracoes.map((config) => {
                                const name = `dreMercadologicaImpostos[${config.index}].vlTotal`;
                                const tooltip = config.dreMercadologicaConfigImposto.dsObservacao;

                                return (
                                    <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', gap: 1.5 }} key={config.idDreMercadologicaImposto}>
                                        <CissNumberField
                                            name={name}
                                            inputType="decimal"
                                            value={config.vlTotal}
                                            error={getIn(errors, name)}
                                            onBlur={recalculateValidatedDre}
                                            label={`${config.dreMercadologicaConfigImposto.dsNomeExibicao} (R$)`}
                                            onChange={(e) => setFieldValue(name, Number(e.target.value))}
                                        />

                                        {tooltip && (
                                            <Tooltip title={tooltip}>
                                                <InfoOutlined />
                                            </Tooltip>
                                        )}
                                    </Box>
                                );
                            })}
                        </DreFormRow>
                    ),
                )}
            </DreFormGroup>
        ),
        [values.dreMercadologicaImpostos, errors.dreMercadologicaImpostos],
    );
}
